import { render } from "./DesktopFilters.vue?vue&type=template&id=15c6245d"
import script from "./DesktopFilters.vue?vue&type=script&lang=js"
export * from "./DesktopFilters.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Dev\\Personal\\reethi-inertia\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__